// 메신저 알림 주소(/messenger?post=<MM 글 id>) → iframe 이 열 MM 영구링크(/mm/<팀>/pl/<글 id>)
// (patch_mm_push_click_opens_post.md). 서버(mm_notify._push)가 푸시 주소에 글 id 를 싣고,
// EmbedPage 가 세션 확인 뒤 goMatch(영구링크)·goSso(SSO 뒤 영구링크)로 그 글을 연다.
// 🔴 MM 글 id 는 26자 [a-z0-9] — 그 밖은 버린다(주소로 iframe 을 딴 데로 보내지 못하게).
export const MM_POST_PARAM = 'post';
const MM_POST_ID_RE = /^[a-z0-9]{26}$/;

export function mmPostIdFromSearch(search) {
  try {
    const id = new URLSearchParams(search || '').get(MM_POST_PARAM);
    return id && MM_POST_ID_RE.test(id) ? id : null;
  } catch (e) { return null; }
}

export function mmPermalink(appRoot, id) {
  return appRoot && id ? `${appRoot.replace(/\/+$/, '')}/pl/${id}` : null;
}

// SSO 뒤 MM 이 갈 곳 — redirect_to 는 MM SiteURL 서브패스(/mm) 뒤에 붙는다(EmbedHost.jsx EMBED_APPS.messenger 주석)
// → '/ourbox/pl/<id>'. '/mm/ourbox/pl/…' 로 주면 '/mm/mm/…' 이 되어 팀을 못 찾는다.
export function mmSsoUrlForPost(ssoUrl, appRoot, id) {
  if (!ssoUrl || !id) return ssoUrl;
  const team = (appRoot || '').replace(/^\/mm(?=\/|$)/, '').replace(/\/+$/, '');   // '/mm/ourbox' → '/ourbox'
  return ssoUrl.replace(/redirect_to=[^&]*/, `redirect_to=${encodeURIComponent(`${team}/pl/${id}`)}`);
}

// 읽은 뒤 주소에서 ?post= 를 지운다(새로고침마다 그 글로 다시 튀지 않게 · 다른 쿼리·해시·history.state 는 둔다).
export function stripMmPostParam(win) {
  try {
    const u = new URL(win.location.href);
    if (!u.searchParams.has(MM_POST_PARAM)) return;
    u.searchParams.delete(MM_POST_PARAM);
    win.history.replaceState(win.history.state, '', u.pathname + (u.search || '') + (u.hash || ''));
  } catch (e) { /* */ }
}
